module.exports = __webpack_public_path__ + "img/rotate-smartphone@2x.97578559.png";